import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment';
import stars from '../images/stars-in-the-night-sky.jpg';
import bedTimeSound from '../sounds/twinkle-twinkle-little-star-mozart.mp3';
import wakeTimeSound from '../sounds/rooster-sound.mp3';
import alarmSound from '../sounds/times-up.mp3';
import constants from '../consts/canvas-clock-consts';
import settings from '../settings';

import BedTimePopup from './popup_bedtime';
import TimerPopup from './popup_timer';
import SettingsPopup from './popup_settings';
import EventsPopup from './popup_events';

import GoogleService from '../services/google';

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMoon, faCog, faCircle, faHourglass, faCalendarAlt } from '@fortawesome/free-solid-svg-icons'

library.add(faMoon, faHourglass, faCog, faCalendarAlt, faCircle)

// react native canvas https://alibaba.github.io/GCanvas/docs/Introduction.html

class CanvasClockComponent extends Component {

    constructor() {
        super();
        this.state = {
            showBedTimeInput: false,
            showBedTime: false,
            showTimerInput: false,
            showTimer: false,
            startBedTimeHour: 1,
            startBedTimeMinute: 0,
            startBedTimeAmPm: 1,
            endBedTimeHour: 1,
            endBedTimeMinute: 0,
            endBedTimeAmPm: 0,
            splitBedAndWakeTime: true,
            startTimerMinutes: 1,
            endTimerInSeconds: 0,
            showSettingsInput: false,
            showEventsInput: false,
            showEvents: false,
            showButtons: false,
            showCalendarSelection: false,
            buttonStyles: {},
            settings,
            events: {}
        }

        this.canvasClicked = this.canvasClicked.bind(this);
        this.drawClock = this.drawClock.bind(this);
    }

    componentDidMount() {
        this.checkLocalStorage();
        this.img = new Image();
        this.img.src = stars;
        this.img.onload = () => {
            this.initCanvas();
        };

        this.service = new GoogleService();
    }

    playBedTimeAudio() {
        this.bedTimeSound.play();
    }

    playWakeTimeAudio() {
        this.wakeTimeSound.play();
    }

    playAlarmAudio() {
        this.alarmSound.play();
    }

    checkLocalStorage() {
        this.setState({
            showBedTime: localStorage.getItem(constants.BEDTIME_SHOW) || this.state.showBedTime,
            startBedTimeHour: localStorage.getItem(constants.BEDTIME_START_HOUR) != null ? parseInt(localStorage.getItem(constants.BEDTIME_START_HOUR)) : this.state.startBedTimeHour,
            startBedTimeMinute: localStorage.getItem(constants.BEDTIME_START_MINUTE) != null ? parseInt(localStorage.getItem(constants.BEDTIME_START_MINUTE)) : this.state.startBedTimeMinute,
            startBedTimeAmPm: localStorage.getItem(constants.BEDTIME_START_AMPM) != null ? parseInt(localStorage.getItem(constants.BEDTIME_START_AMPM)) : this.state.startBedTimeAmPm,
            endBedTimeHour: localStorage.getItem(constants.BEDTIME_END_HOUR) != null ? parseInt(localStorage.getItem(constants.BEDTIME_END_HOUR)) : this.state.endBedTimeHour,
            endBedTimeMinute: localStorage.getItem(constants.BEDTIME_END_MINUTE) != null ? parseInt(localStorage.getItem(constants.BEDTIME_END_MINUTE)) : this.state.endBedTimeMinute,
            endBedTimeAmPm: localStorage.getItem(constants.BEDTIME_END_AMPM) != null ? parseInt(localStorage.getItem(constants.BEDTIME_END_AMPM)) : this.state.endBedTimeAmPm,
            showTimer: localStorage.getItem(constants.TIMER_SHOW) != null ? localStorage.getItem(constants.TIMER_SHOW) : this.state.showTimer,
            startTimerMinutes: localStorage.getItem(constants.TIMER_START_MINUTE) != null ? parseInt(localStorage.getItem(constants.TIMER_START_MINUTE)) : this.state.startTimerMinutes,
            endTimerInSeconds: localStorage.getItem(constants.TIMER_END_TIME_IN_SECONDS) != null ? parseInt(localStorage.getItem(constants.TIMER_END_TIME_IN_SECONDS)) : this.state.endTimerInSeconds,
            settings: localStorage.getItem(constants.SETTINGS) != null ? JSON.parse(localStorage.getItem(constants.SETTINGS)) : this.state.settings,
            showEvents: localStorage.getItem(constants.EVENTS_SHOW) != null ? localStorage.getItem(constants.EVENTS_SHOW) : this.state.showEvents,
            events: localStorage.getItem(constants.EVENTS) != null ? JSON.parse(localStorage.getItem(constants.EVENTS)) : this.state.events,
        })
    }

    initCanvas() {
        this.canvas = this.refs.canvas;
        this.canvas.addEventListener('click', this.canvasClicked, false);
        this.ctx = this.canvas.getContext("2d");

        this.dpi = window.devicePixelRatio || 1;
        this.ctx.scale(this.dpi, this.dpi);

        setInterval(this.drawClock, 1000);
        setTimeout(() => {
            this.setState({ showButtons: true });
        }, 1000);

        window.addEventListener('resize', this.drawClock, false);
    }

    drawClock() {
        this.setCanvasDimensions();
        this.drawFace();
        this.drawEvents()
        this.drawBedTime();
        this.drawCountdownTimer();
        this.drawNumbers();
        this.drawTime();
    }

    setCanvasDimensions() {
        var canvasSize = window.innerWidth;
        if (window.innerWidth > window.innerHeight) {
            canvasSize = window.innerHeight;
        }

        //this.canvas.setAttribute("height", canvasSize * dpi);
        //this.canvas.setAttribute("width", canvasSize * dpi);

        var style_height = +getComputedStyle(this.canvas).getPropertyValue("height").slice(0, -2);
        var style_width = +getComputedStyle(this.canvas).getPropertyValue("width").slice(0, -2);

        //console.log(`style_height ${style_height}, style_width: ${style_width}`);

        this.canvas.width = canvasSize;
        this.canvas.height = canvasSize;

        //console.log(`Client Height ${this.canvas.clientHeight}, Client Width: ${this.canvas.clientWidth}`);

        this.originalRadius = this.canvas.width / 2;
        this.ctx.translate(this.originalRadius, this.originalRadius);
        this.radius = this.originalRadius * 0.90;

        this.setState({ buttonStyles: { width: this.radius * 0.15 * 2, height: this.radius * 0.15 * 2 } });
    }

    drawFace() {
        // body
        var ctx = this.ctx;
        var radius = this.radius;
        ctx.beginPath();
        ctx.arc(0, 0, radius, 0, 2 * Math.PI);
        ctx.fillStyle = this.state.settings.clock_face_color.value;
        ctx.fill();

        ctx.strokeStyle = this.state.settings.clock_border_color.value;
        ctx.lineWidth = radius * 0.05;
        ctx.stroke();
    }

    drawNumbers() {
        var ang,
            num,
            ctx = this.ctx,
            radius = this.radius;

        ctx.font = radius * 0.15 + "px arial";
        ctx.textBaseline = "middle";
        ctx.textAlign = "center";
        for (num = 1; num < 13; num++) {
            ang = num * Math.PI / 6;
            ctx.rotate(ang);
            ctx.translate(0, -radius * 0.85);
            ctx.rotate(-ang);
            ctx.fillStyle = this.state.settings.clock_numbers_color.value === 'multi' ? constants.CLOCK_NUMBER_COLORS[num - 1] : this.state.settings.clock_numbers_color.value;
            ctx.fillText(num.toString(), 0, 0);
            ctx.rotate(ang);
            ctx.translate(0, radius * 0.85);
            ctx.rotate(-ang);
        }

        for (let line = 1; line < 61; line++) {
            ang = line * Math.PI / 30;
            ctx.rotate(ang);
            ctx.translate(0, -radius * 0.98);
            ctx.fillStyle = this.state.settings.clock_number_ticks_color.value;
            var fillWidth = radius * 0.02;
            var fillHeight = radius * 0.03;
            if (line % 5 === 0) {
                fillHeight = radius * 0.05;
            }
            ctx.fillRect(0, 0, fillWidth, fillHeight);
            ctx.translate(0, radius * 0.98);
            ctx.rotate(-ang);
        }
    }

    drawTime() {
        var ctx = this.ctx,
            radius = this.radius;

        //center circle
        ctx.beginPath();
        ctx.arc(0, 0, radius * 0.05, 0, 2 * Math.PI);
        ctx.fillStyle = this.state.settings.clock_border_color.value;
        ctx.fill();

        var now = new Date();
        this.hour = now.getHours();
        this.minute = now.getMinutes();
        this.second = now.getSeconds();
        //hour
        var hour = this.hour % 12;
        hour = (hour * Math.PI / 6) +
            (this.minute * Math.PI / (6 * 60)) +
            (this.second * Math.PI / (360 * 60));

        this.drawHand(hour, radius * 0.5, radius * 0.07, this.state.settings.clock_hour_hand_color.value);
        //minute
        var minute = (this.minute * Math.PI / 30) + (this.second * Math.PI / (30 * 60));
        this.drawHand(minute, radius * 0.8, radius * 0.07, this.state.settings.clock_minute_hand_color.value);
        // second
        var second = (this.second * Math.PI / 30);
        this.drawHand(second, radius * 0.9, radius * 0.02, this.state.settings.clock_seconds_hand_color.value);
    }

    drawHand(pos, length, width, color) {
        var ctx = this.ctx;

        ctx.beginPath();
        ctx.lineWidth = width;
        ctx.lineCap = "round";

        ctx.moveTo(0, 0);
        ctx.rotate(pos);
        ctx.lineTo(0, -length);
        ctx.strokeStyle = color;
        ctx.stroke();
        ctx.rotate(-pos);
    }

    drawBedTime() {
        var ctx = this.ctx;
        var radius = this.radius;
        var bedTimeRadius = 0.98;

        this.hour = this.hour || new Date().getHours();
        this.minute = this.minute || new Date().getMinutes();

        if (this.state.showBedTime) {
            var twentyFourHourStartTime = this.state.startBedTimeAmPm === 1 ? this.state.startBedTimeHour + 12 : this.state.startBedTimeHour;
            var twentyFourHourEndTime = this.state.endBedTimeAmPm === 1 ? this.state.endBedTimeHour + 12 : this.state.endBedTimeHour;

            // if it's am and we set the bedtime for pm, show bedTime at 50% radius
            if (
                this.hour < 12 &&
                twentyFourHourStartTime > 12
            ) {
                bedTimeRadius = 0.50;
            }

            if (this.hour === twentyFourHourStartTime &&
                this.minute === this.state.startBedTimeMinute * .6) {
                this.playBedTimeAudio();
            }

            if (this.hour === twentyFourHourEndTime &&
                this.minute === this.state.endBedTimeMinute * .6) {
                this.playWakeTimeAudio();
                this.setState({ showBedTime: false });
                return;
            }

            const arcStartTime = 3;
            var startBedTimeHour = this.state.startBedTimeHour;
            var endBedTimeHour = this.state.endBedTimeHour;
            var endBedTimeMinute = this.state.endBedTimeMinute;

            // if bedtime start is pm and endBedTime is am and current time is less than the start time
            //  make the endBedTime midnight
            if (
                this.state.startBedTimeAmPm === 1 &&
                this.state.endBedTimeAmPm === 0 &&
                this.hour < twentyFourHourStartTime) {
                endBedTimeHour = 12;
                endBedTimeMinute = 0;
            }

            var startTime = (startBedTimeHour + (this.state.startBedTimeMinute / 100)) - arcStartTime;
            var finishTime = (endBedTimeHour + (endBedTimeMinute / 100)) - arcStartTime;
            var startAngle = (startTime * Math.PI / 6)
            var endAngle = (finishTime * Math.PI / 6)
            if (startTime === finishTime) {
                startAngle = 0;
                endAngle = 2 * Math.PI;
            }

            ctx.save();
            ctx.beginPath();
            ctx.moveTo(0, 0);
            ctx.arc(0, 0, radius * bedTimeRadius, startAngle, endAngle);
            ctx.globalAlpha = 0.85;
            var pattern = ctx.createPattern(this.img, 'repeat');
            ctx.fillStyle = pattern;
            ctx.translate(this.canvas.width, this.canvas.height);
            ctx.fill();
            ctx.globalAlpha = 1;
            ctx.restore();
        }
    }

    drawCountdownTimer() {
        var ctx = this.ctx,
            radius = this.radius,
            endAngle = (0 - 3 * Math.PI / 6);

        if (this.state.showTimer) {
            this.setState({ currentTimeInSeconds: Math.floor(new Date().getTime() / 1000) });
            if (this.state.currentTimeInSeconds >= this.state.endTimerInSeconds) {
                this.playAlarmAudio();
                this.clearTimer();
                return;
            }

            var remainingSeconds = this.state.endTimerInSeconds - this.state.currentTimeInSeconds;
            var convertedTime = 60 - (remainingSeconds / 60);
            var startAngle = (((convertedTime * 60) - (15 * 60)) * Math.PI / (30 * 60));

            ctx.save();
            ctx.beginPath();
            ctx.moveTo(0, 0);
            ctx.arc(0, 0, radius * 0.98, startAngle, endAngle);
            ctx.globalAlpha = 0.85;
            ctx.fillStyle = '#a92120';
            ctx.fill();
            ctx.globalAlpha = 1;
            ctx.restore();
        }
    }

    drawEvents() {
        var ctx = this.ctx,
            radius = this.radius;

        if (this.state.showEvents) {
            for (let i = 0; i < this.state.events.length; i++) {
                const event = this.state.events[i];
                const { summary, start: { dateTime: startDate }, end: { dateTime: endDate }, color } = event;

                //console.log(`endTime: ${moment(endTime)} now ${moment()} is this true? ${moment(endTime).isBefore(moment())}`);
                const momentStart = moment(startDate);
                const momentEnd = moment(endDate)

                if (moment(endDate).isAfter(moment())) {
                    this.drawEvent(summary, momentStart, momentEnd, color);
                }
            }

            const currentEvent = _.find(this.state.events, event => moment().isBetween(event.start.dateTime, event.end.dateTime));
            if (currentEvent) {
                ctx.font = radius * 0.05 + "px arial";
                ctx.textBaseline = "middle";
                ctx.textAlign = "center";
                ctx.fillStyle = '#000';
                ctx.fillText("Current".toUpperCase(), 0, radius * 0.2);

                ctx.font = radius * 0.15 + "px arial";
                ctx.textBaseline = "middle";
                ctx.textAlign = "center";
                ctx.fillStyle = '#000';
                ctx.fillText(currentEvent.summary.toUpperCase().toString(), 0, radius * 0.3);
            }

            const nextEvent = _.find(this.state.events, event => !moment().isBetween(event.start.dateTime, event.end.dateTime) && moment(event.end.dateTime).isAfter(moment()));
            if (nextEvent) {
                const [startTimeHour, startTimeMinute] = moment(nextEvent.start.dateTime).clone().format('HH:mm').split(':');
                ctx.font = radius * 0.04 + "px arial";
                ctx.textBaseline = "middle";
                ctx.textAlign = "center";
                ctx.fillStyle = '#000';
                ctx.fillText("Up Next".toUpperCase(), 0, radius * 0.55);

                var leftTime = moment(nextEvent.start.dateTime).fromNow(); // this need to be more precise 
                ctx.font = radius * 0.045 + "px arial";
                ctx.textBaseline = "middle";
                ctx.textAlign = "center";
                ctx.fillStyle = '#000';
                ctx.fillText(`${nextEvent.summary.toUpperCase()} ${leftTime}`.toString(), 0, radius * 0.6);
            }
        }
    }

    drawEvent(summary, startDate, endDate, color) {
        const ctx = this.ctx,
            radius = this.radius,
            startTime = startDate.clone().format('HH:mm'),
            endTime = endDate.clone().format('HH:mm');

        // console.log(`drawing daily events - summary: ${summary}, startDate: ${startDate}, endDate: ${endDate}, color: ${color}`);
        const arcStartTime = 3;
        const startTime24Hour = startTime.split(':')[0];
        const startTimeMinute = startTime.split(':')[1];
        const endTime24Hour = endTime.split(':')[0];
        const endTimeMinute = endTime.split(':')[1];

        const startTimeHour = startTime24Hour % 12;
        const endTimeHour = endTime24Hour % 12;

        var beginningTime = (startTimeHour + (startTimeMinute / 60)) - arcStartTime;
        var finishTime = (endTimeHour + (endTimeMinute / 60)) - arcStartTime;
        var startAngle = (beginningTime * Math.PI / 6)
        var endAngle = (finishTime * Math.PI / 6)

        let eventRadius = this.radius;
        // if it's am and the events are am, make full radius and pm half radius
        if (startTime24Hour < 12) {
            eventRadius = eventRadius / 2;
        }

        ctx.save();
        ctx.beginPath();
        ctx.moveTo(0, 0);
        ctx.arc(0, 0, eventRadius * 0.98, startAngle, endAngle);
        ctx.globalAlpha = 0.75;
        ctx.fillStyle = color || 'green';
        ctx.fill();

        ctx.strokeStyle = 'black';
        ctx.lineWidth = radius * 0.01;
        ctx.stroke();
        ctx.globalAlpha = 1;
        ctx.restore();
    }

    canvasClicked({ clientX, clientY }) {
        var rect = this.canvas.getBoundingClientRect();
        var x = clientX - rect.left;
        var y = clientY - rect.top // - (this.originalRadius - this.radius);
        if (this.isCenterClicked(x, y)) {
            if (this.state.showButtons === true) {
                this.hideButtons();
            } else {
                this.showButtons();
            }
        }

    }

    isCenterClicked(x, y) {
        var center = this.canvas.width / 2;
        return this.pointInCircle(x, y, center, center, this.radius * 0.05);
    }

    pointInCircle(x, y, cx, cy, radius) {
        return (((x - cx) * (x - cx)) + ((y - cy) * (y - cy))) <= (radius * radius);
    }

    bedTimeHourStartChanged(e) {
        this.setState({ startBedTimeHour: parseInt(e.target.value) });
    }

    bedTimeMinuteStartChanged(e) {
        this.setState({ startBedTimeMinute: parseInt(e.target.value) });
    }

    bedTimeAmPmStartChanged(e) {
        this.setState({ startBedTimeAmPm: parseInt(e.target.value) });
    }

    bedTimeHourEndChanged(e) {
        this.setState({ endBedTimeHour: parseInt(e.target.value) });
    }

    bedTimeMinuteEndChanged(e) {
        this.setState({ endBedTimeMinute: parseInt(e.target.value) });
    }

    bedTimeAmPmEndChanged(e) {
        this.setState({ endBedTimeAmPm: parseInt(e.target.value) });
    }

    timerStartChanged(e) {
        this.setState({ startTimerMinutes: parseInt(e.target.value) });
    }

    showBedTime() {
        this.showButtons();
        this.setState({ showBedTime: true, showBedTimeInput: false }, () => {
            this.addToLocalStorage({
                BEDTIME_SHOW: this.state.showBedTime,
                BEDTIME_START_HOUR: this.state.startBedTimeHour,
                BEDTIME_START_MINUTE: this.state.startBedTimeMinute,
                BEDTIME_START_AMPM: this.state.startBedTimeAmPm,
                BEDTIME_END_HOUR: this.state.endBedTimeHour,
                BEDTIME_END_MINUTE: this.state.endBedTimeMinute,
                BEDTIME_END_AMPM: this.state.endBedTimeAmPm
            });
        });
    }

    clearBedTime() {
        this.showButtons();
        this.setState({
            showBedTime: false,
            showBedTimeInput: false,
            startBedTimeHour: 1,
            startBedTimeMinute: 0,
            startBedTimeAmPm: 1,
            endBedTimeHour: 1,
            endBedTimeMinute: 0,
            endBedTimeAmPm: 0
        });
        this.removeFromLocalStorage([
            constants.BEDTIME_SHOW,
            constants.BEDTIME_START_HOUR,
            constants.BEDTIME_START_MINUTE,
            constants.BEDTIME_START_AMPM,
            constants.BEDTIME_END_HOUR,
            constants.BEDTIME_END_MINUTE,
            constants.BEDTIME_END_AMPM
        ]);
    }

    showTimer() {
        this.showButtons();
        var currentTimeInSeconds = Math.floor(new Date().getTime() / 1000),
            endTimerInSeconds = this.state.startTimerMinutes * 60 + currentTimeInSeconds;

        this.setState({
            showTimer: true,
            showTimerInput: false,
            currentTimeInSeconds: currentTimeInSeconds,
            endTimerInSeconds: endTimerInSeconds
        }, () => {
            this.addToLocalStorage({
                TIMER_SHOW: this.state.showTimer,
                TIMER_START_MINUTE: this.state.startTimerMinutes,
                TIMER_END_TIME_IN_SECONDS: this.state.endTimerInSeconds
            });
        });
    }

    clearTimer() {
        this.showButtons();
        this.setState({
            showTimer: false,
            showTimerInput: false,
        });
        this.removeFromLocalStorage([
            constants.TIMER_SHOW,
            constants.TIMER_START_MINUTE,
            constants.TIMER_END_TIME_IN_SECONDS
        ]);
    }

    bedTimeButtonClicked() {
        this.bedTimeSound = new Audio(bedTimeSound);
        this.wakeTimeSound = new Audio(wakeTimeSound);
        this.bedTimeSound.play();
        this.wakeTimeSound.play();
        setTimeout(() => { this.bedTimeSound.pause(); this.wakeTimeSound.pause(); }, 200);
        var showBedTimeInput = this.state.showBedTimeInput !== true;
        this.setState({ showBedTimeInput });
        this.hideButtons();
    }

    timerButtonClicked() {
        this.alarmSound = new Audio(alarmSound);
        this.alarmSound.play();
        setTimeout(() => { this.alarmSound.pause(); }, 200);
        var showTimerInput = this.state.showTimerInput !== true;
        this.setState({ showTimerInput });
        this.hideButtons();
    }

    settingsButtonClicked() {
        var showSettingsInput = this.state.showSettingsInput !== true;
        this.setState({ showSettingsInput });
        this.hideButtons();
    }

    setSettings() {
        const newSettings = _.cloneDeep(this.state.settings);
        Array.from(document.getElementsByClassName('settings-input')).forEach(
            function (element) {
                const name = element.getAttribute('name');
                const value = element.getAttribute('value');
                newSettings[name].value = value;
            }
        );

        this.showButtons();
        this.setState({
            showSettingsInput: false,
            settings: newSettings
        }, () => {
            this.addToLocalStorage({
                SETTINGS: JSON.stringify(newSettings)
            });
        });
    }

    calendarButtonClicked() {
        var showEventsInput = this.state.showEventsInput !== true;
        this.setState({ showEventsInput });
        this.hideButtons();
    }

    oAuthSuccess(response) {
        //console.log(response.getGrantedScopes());
        this.service.initCalendar(response.accessToken);
        this.service.getCalendars()
            .then(items => {
                this.setState({
                    showCalendarSelection: true,
                    calendars: items
                });
            });
    }

    oAuthFailure(response) {
        // TODO: show response to the user
        alert(JSON.stringify(response));
    }

    oAuthLogout() {
        this.clearEvents();
    }

    onCalendarChange(e) {
        this.getEvents(e.target.value);
    }

    getEvents(calendarId) {
        this.service.getEvents(calendarId)
            .then(events => {
                this.setState({
                    events,
                    calendarId
                }, () => {
                    this.addToLocalStorage({
                        EVENTS: JSON.stringify(this.state.events)
                    });
                });
            });
    }

    refreshEvents() {
        this.getEvents(this.state.calendarId);
    }

    setEvents() {
        this.showButtons();
        this.setState({
            showEvents: true,
            showEventsInput: false
        }, () => {
            this.addToLocalStorage({
                EVENTS_SHOW: this.state.showEvents
            })
        });
    }

    clearEvents() {
        this.showButtons();
        this.setState({
            events: {},
            showEvents: false,
            showEventsInput: false,
        });
        this.removeFromLocalStorage([
            constants.EVENTS_SHOW,
            constants.EVENTS
        ]);
    }

    getButtonDimensions() {
        return this.radius * 0.15 * 2;
    }

    showButtons() {
        this.setState({ showButtons: true });
    }

    hideButtons() {
        this.setState({ showButtons: false });
    }

    removeFromLocalStorage(keys) {
        keys.forEach(key => {
            localStorage.removeItem(key);
        });
    }

    addToLocalStorage(items) {
        Object.keys(items).forEach(key => {
            localStorage.setItem(key, items[key]);
        })
    }

    render() {
        return (
            <div className="canvas-clock">
                <style dangerouslySetInnerHTML={{
                    __html: `
                .App-header { background: ${this.state.settings.background_color.value}; }
            `}}></style>
                <BedTimePopup
                    showBedTimeInput={this.state.showBedTimeInput}
                    startBedTimeHour={this.state.startBedTimeHour}
                    startBedTimeMinute={this.state.startBedTimeMinute}
                    startBedTimeAmPm={this.state.startBedTimeAmPm}
                    endBedTimeHour={this.state.endBedTimeHour}
                    endBedTimeMinute={this.state.endBedTimeMinute}
                    endBedTimeAmPm={this.state.endBedTimeAmPm}
                    clearBedTime={this.clearBedTime.bind(this)}
                    showBedTime={this.showBedTime.bind(this)}
                    bedTimeHourStartChanged={this.bedTimeHourStartChanged.bind(this)}
                    bedTimeMinuteStartChanged={this.bedTimeMinuteStartChanged.bind(this)}
                    bedTimeAmPmStartChanged={this.bedTimeAmPmStartChanged.bind(this)}
                    bedTimeHourEndChanged={this.bedTimeHourEndChanged.bind(this)}
                    bedTimeMinuteEndChanged={this.bedTimeMinuteEndChanged.bind(this)}
                    bedTimeAmPmEndChanged={this.bedTimeAmPmEndChanged.bind(this)}
                />
                <TimerPopup
                    showTimerInput={this.state.showTimerInput}
                    startTimerMinutes={this.state.startTimerMinutes}
                    timerStartChanged={this.timerStartChanged.bind(this)}
                    clearTimer={this.clearTimer.bind(this)}
                    showTimer={this.showTimer.bind(this)}
                />
                <SettingsPopup
                    showSettingsInput={this.state.showSettingsInput}
                    setSettings={this.setSettings.bind(this)}
                    settings={this.state.settings}
                />
                <EventsPopup
                    showEventsInput={this.state.showEventsInput}
                    setEvents={this.setEvents.bind(this)}
                    clearEvents={this.clearEvents.bind(this)}
                    oAuthSuccess={this.oAuthSuccess.bind(this)}
                    oAuthLogout={this.oAuthLogout.bind(this)}
                    oAuthFailure={this.oAuthFailure.bind(this)}
                    showCalendarSelection={this.state.showCalendarSelection}
                    calendars={this.state.calendars}
                    onCalendarChange={this.onCalendarChange.bind(this)}
                    refreshEvents={this.refreshEvents.bind(this)}
                />
                <button className="tl button-icons" onClick={this.bedTimeButtonClicked.bind(this)} style={this.state.showButtons ? {} : { display: 'none' }}><FontAwesomeIcon color={this.state.settings.button_color.value} icon="moon" mask="circle" size="2x" transform="shrink-6" style={this.state.buttonStyles} /></button>
                <button className="tr button-icons" onClick={this.timerButtonClicked.bind(this)} style={this.state.showButtons ? {} : { display: 'none' }}><FontAwesomeIcon color={this.state.settings.button_color.value} icon="hourglass" mask="circle" size="2x" transform="shrink-6" style={this.state.buttonStyles} /></button>
                <button className="bl button-icons" onClick={this.settingsButtonClicked.bind(this)} style={this.state.showButtons ? {} : { display: 'none' }}><FontAwesomeIcon color={this.state.settings.button_color.value} icon="cog" mask="circle" size="2x" transform="shrink-6" style={this.state.buttonStyles} /></button>
                <button className="br button-icons" onClick={this.calendarButtonClicked.bind(this)} style={this.state.showButtons ? {} : { display: 'none' }}><FontAwesomeIcon color={this.state.settings.button_color.value} icon="calendar-alt" mask="circle" size="2x" transform="shrink-6" style={this.state.buttonStyles} /></button>
                <canvas ref="canvas" width={300} height={300} />
            </div>
        );
    }
}

export default CanvasClockComponent;